<template>
    <div :class="wrapClasses" :style="styles">
        <div :class="[prefixCls + '-tail']"><i></i></div>
        <div :class="[prefixCls + '-head']">
            <div :class="[prefixCls + '-head-inner']">
                <span v-if="!icon && currentStatus != 'finish' && currentStatus != 'error'" class="wait-step"></span>
                <span v-else class="finish-step"></span>
                <span class="step-short-line"><i></i></span>
            </div>
        </div>
        <div :class="[prefixCls + '-main']">
            <div :class="[prefixCls + '-title']">{{ title }}</div>
            <slot>
                <div v-if="content" :class="[prefixCls + '-content']">{{ content }}</div>
            </slot>
        </div>
    </div>
</template>
<script>
import { oneOf } from '@/business/utils'
import Emitter from '@/business/emitter'

const prefixCls = 'ivu-steps'
const iconPrefixCls = 'ivu-icon'

export default {
  name: 'AbStep',
  mixins: [ Emitter ],
  props: {
    status: {
      validator (value) {
        return oneOf(value, ['wait', 'wait', 'finish', 'error'])
      }
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String
    },
    icon: {
      type: String
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      stepNumber: '',
      nextError: false,
      total: 1,
      currentStatus: ''
    }
  },
  computed: {
    wrapClasses () {
      return [
        `${prefixCls}-item`,
        `${prefixCls}-status-${this.currentStatus}`,
        {
          [`${prefixCls}-custom`]: !!this.icon,
          [`${prefixCls}-next-error`]: this.nextError
        }
      ]
    },
    iconClasses () {
      let icon = ''

      if (this.icon) {
        icon = this.icon
      } else {
        if (this.currentStatus == 'finish') {
          icon = 'ios-checkmark'
        } else if (this.currentStatus == 'error') {
          icon = 'ios-close'
        }
      }

      return [
        `${prefixCls}-icon`,
        `${iconPrefixCls}`,
        {
          [`${iconPrefixCls}-${icon}`]: icon != ''
        }
      ]
    },
    styles () {
      return {
        width: `${1 / this.total * 100}%`
      }
    }
  },
  watch: {
    status (val) {
      this.currentStatus = val
      if (this.currentStatus == 'error') {
        this.$parent.setNextError()
      }
    }
  },
  created () {
    this.currentStatus = this.status
  },
  mounted () {
    this.dispatch('AbSteps', 'append')
  },
  beforeDestroy () {
    this.dispatch('AbSteps', 'remove')
  }
}
</script>

<style lang="scss" scoped>
.ivu-steps {
  .ivu-steps-tail {
    padding: 0;
    top: 8px;
    i {
      height: 8px;
      border-top: 1px solid;
      border-bottom: 1px solid;
      background: #ffffff;
      color: #D8D8D8;
      &::after {
        content: '';
        width: 0;
        height: 4px;
        background: #e8eaec;
        opacity: 0;
        position: absolute;
        top: 1px;
      }
    }
  }
  .ivu-steps-head {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: none;
    z-index: 5;
    .step-short-line {
      position: absolute;
      top: 50%;
      left: -1px;
      transform: translateY(-50%);
      z-index: 3;
      width: 26px;
      height: 8px;
      i {
        display: inline-block;
        height: 8px;
        width: 100%;
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
        background: #ffffff;
        color: #D8D8D8;
        vertical-align: top;
        &::after {
          content: '';
          width: 100%;
          height: 4px;
          background: #D8D8D8;
          opacity: 0;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 2px;
        }
      }
    }
  }
  .ivu-steps-head-inner {
    margin: 0;
    height: 24px;
    line-height: 24px;
    width: 24px;
    text-align: center;
    z-index: 5;
    border: 1px solid #dadada;
    .finish-step, .wait-step {
      position: relative;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #E0E0E0;
      z-index: 6;
    }
  }
  .ivu-steps-main {
    position: absolute;
    text-align: center;
    left: 50%;
    top: 26px;
    transform: translateX(-50%);
    display: inline-block;
    width: 100%;
  }
  .ivu-steps-title {
    padding: 0;
    background: none;
    font-size: 24px;
    color: #999999;
  }
  .ivu-steps-content {
    display: none;
  }
  .ivu-steps-item {
    &:last-child, &:first-child {
      .ivu-steps-tail {
        display: block;
        width: 50%;
      }
    }
    &:first-child {
      .ivu-steps-tail {
        left: 50%;
      }
      .step-short-line {
        width: 12px !important;
        right: 0px;
        left: 50% !important;
      }
    }
    &:last-child {
      .step-short-line {
        width: 12px !important;
        left: 0px !important;
      }
    }
    &.ivu-steps-status-finish {
      .ivu-steps-tail>i:after {
        width: 100%;
        background: #FF7A45;
        transition: all .2s ease-in-out;
        opacity: 1;
      }
      .ivu-steps-head-inner {
        .finish-step {
          background: #FF7A45;
        }
      }
      .ivu-steps-head {
        .step-short-line {
          width: 24px;
          left: 0px;
          i {
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
            &::after {
              content: '';
              width: 100%;
              height: 4px;
              background: #FF7A45;
              opacity: 1;
              display: inline-block;
              position: absolute;
              left: 0;
              top: 2px;
            }
          }
        }
      }
      .ivu-steps-title {
        color: #FF7A45;
      }
      .ivu-steps-content {
        display: block;
        color: #FF7A45;
      }
    }
  }
}
.ivu-steps-horizontal .ivu-steps-item:not(:first-child) .ivu-steps-head {
  margin: 0;
  padding: 0;
}
.ivu-steps-horizontal .ivu-steps-content {
  padding: 0;
}

</style>
